import { render } from "./ArrayListGrouped.vue?vue&type=template&id=05ff775e"
import script from "./ArrayListGrouped.vue?vue&type=script&lang=js"
export * from "./ArrayListGrouped.vue?vue&type=script&lang=js"

import "./ArrayListGrouped.vue?vue&type=style&index=0&id=05ff775e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__